var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16659 16.8334C0.706352 16.8334 0.333252 16.4603 0.333252 16.0001V1.00008C0.333252 0.539848 0.706352 0.166748 1.16659 0.166748H12.8333C13.2935 0.166748 13.6666 0.539848 13.6666 1.00008V3.50008H11.9999V1.83341H1.99992V15.1667H11.9999V13.5001H13.6666V16.0001C13.6666 16.4603 13.2935 16.8334 12.8333 16.8334H1.16659ZM11.9999 11.8334V9.33342H6.16658V7.66675H11.9999V5.16675L16.1666 8.50008L11.9999 11.8334Z",
    fill: "#F9F6F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.10e8415a3bfc7dd056d21b1759679cdd.svg";
export { ForwardRef as ReactComponent };